<template>
  <b-card class="recent-conversations" :class="isDarkMode ? 'dark' : ''">
    <div class="d-flex align-items-center justify-content-between p-3">
      <p class="recent-conversations--title" :class="isDarkMode ? 'dark' : ''">
        Recent Conversations
      </p>
      <b-button
        pill
        size="sm"
        variant="info"
        @click="goToConversationPage()"
      >
        See More
      </b-button>
    </div>
    <b-table
      :items="recentConversationsData"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :responsive="true"
      class="recent-conversations--table"
      :class="isDarkMode ? 'dark' : ''"
      sticky-header
      v-if="recentConversationsData && recentConversationsData.length"
    >
      <template v-slot:cell(recipient)="data">
        <span
          class="recent-conversations--table--agentPhone"
          :class="isDarkMode ? 'dark' : ''"
        >
          <router-link
            v-if="$auth.can('read:conversation')"
            :to="`/admin/conversations/${data.item.conversation_id}`"
            >{{ prettyPhoneNumber(data.item.recipient_number) }}</router-link
          >
          <template v-else>{{
            prettyPhoneNumber(data.item.recipient_number)
          }}</template>
        </span>
      </template>
      <template v-slot:cell(channel)="data">
        <span
          class="text-capitalize fw-bold"
          :class="`convo-archived badge`"
          >{{ data.value }}</span
        >
      </template>
      <template v-slot:cell(language)="data">
        <div class="d-flex align-items-center" v-if="data.value">
          <LanguageCode :languageCode="data.item.language_code" />
          <span class="d-inline-block ml-3">
            <span
              class="top-languages--item-title"
              :class="isDarkMode ? 'dark' : ''"
              >{{ data.value }}</span
            >
          </span>
        </div>
      </template>
      <template v-slot:cell(created_at)="data">
        <span>{{ formatDate(data.value, "MMM D, YYYY h:mm a") }}</span>
      </template>
      <template v-slot:cell(agent)="data">
        <span>{{ data.item.agent_name }}</span>
      </template>
      <template v-slot:cell(duration)="data">
        {{ formatDuration(data.value) }}
      </template>
      <template v-slot:cell(direction)="data">
        <b-icon
          icon="arrow-up-right"
          v-if="data.value === 'outbound'"
          v-b-tooltip.hover
          title="Outbound Conversation"
        ></b-icon>
        <b-icon
          icon="arrow-down-left"
          v-else
          v-b-tooltip.hover
          title="Inbound Conversation"
        ></b-icon>
      </template>
    </b-table>
    <p class="pt-3 text-center" v-else>No Data Found</p>
  </b-card>
</template>

<script>
import LanguageCode from "../../common/LanguageCode.vue";
import formatter from "@/mixins/formatter";
export default {
  name: "RecentConversations",
  props: {
    recentConversationsData: Array,
    isDarkMode: Boolean,
  },
  mixins: [formatter],
  watch: {
    recentConversationsData() {},
  },

  data() {
    return {
      sortBy: "agent",
      sortDesc: false,
      fields: [
        {
          key: "direction",
          sortable: false,
          tdClass: "custom-column",
          label: "",
        },
        { key: "recipient", sortable: false },
        { key: "agent", sortable: false },
        { key: "channel", sortable: false },
        { key: "language", sortable: false },
        { key: "duration", sortable: false },
        { key: "created_at", sortable: true },
      ],
    };
  },
  methods: {
    goToConversationPage() {
      this.$router.push({ path: "/admin/conversations" }).catch(() => {});
    },
  },
  components: {
    LanguageCode,
  },
};
</script>


<style lang="scss">
.recent-conversations {
  &.dark {
    color: #b2b9bf !important;
  }
  &.card {
    height: 614px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    margin-bottom: 0;

    & .card-body {
      height: 100%;
      padding: 0;
    }
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    color: #333843;
    font-weight: 600;
    margin-bottom: 0;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--table {
    height: calc(100% - 50px);
    &.b-table-sticky-header {
      max-height: 520px;
    }
    .custom-column {
      min-width: unset !important;
    }
    &.dark {
      & thead > tr > th {
        background-color: #44475b !important;
        border-top: 1px solid #f0f1f3;
        border-bottom: 1px solid #f0f1f3;
        color: #b2b9bf !important;
      }
      & tbody > tr > td {
        color: #b2b9bf !important;
      }
    }
    & thead > tr > th {
      position: sticky !important;
      padding: 0.75rem 1rem;
      background-color: #f9f9fc !important;
      border-top: 0;
      border-bottom: 1px solid #f0f1f3;
      color: #333843 !important;
      font-size: 0.875rem;
      font-weight: 500;
      text-align: center;
    }
    & tbody > tr > td {
      color: #667085 !important;
      font-size: 0.875rem;
      font-weight: 400;
      padding: 0.75rem 1rem;
      vertical-align: middle;
      min-width: 150px;
      text-align: center;
    }
    &--agentName,
    &--customerName {
      color: #333843;
      font-weight: 500;
      font-size: 0.875rem;
      display: block;
    }
    &--agentPhone {
      color: #667085;
      font-weight: 400;
      font-size: 0.875rem;
      display: block;
      &.dark {
        a {
          color: #9dc7ff !important;
        }
      }
    }
    &--inbound-text {
      color: #0d894f;
      font-size: 0.875rem;
      background: #e7f4ee;
      font-weight: 500;
      padding: 4px 12px 4px 12px;
      border-radius: 8px;
      &.dark {
        color: #0d894f;
        background: #dae5e0;
      }
    }
    &--outbound-text {
      color: #e46a11;
      font-size: 0.875rem;
      background: #fdf1e8;
      font-weight: 500;
      padding: 4px 12px 4px 12px;
      border-radius: 8px;
      &.dark {
        color: #ba490f;
        background: #e7cab4;
      }
    }
  }
}
</style>